import { siteName, navItems } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center font-heading text-lg font-bold">
                51
              </span>
              <span className="font-heading text-xl font-bold">{siteName}</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-background-100/80 max-w-sm">
              聚合今日爆料、明星与网红黑料、大瓜事件与吃瓜合集，用时间线帮你快速掌握最新动态，不错过任何大瓜。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#top" aria-label="微博" className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center hover:bg-background-50/20 transition-colors">
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </a>
              <a href="#top" aria-label="微信" className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center hover:bg-background-50/20 transition-colors">
                <i className="ri-wechat-line" aria-hidden="true"></i>
              </a>
              <a href="#top" aria-label="站内订阅" className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center hover:bg-background-50/20 transition-colors">
                <i className="ri-rss-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold mb-4">
              <a href="#top" className="hover:text-accent-300 transition-colors">浏览分区</a>
            </h4>
            <ul className="space-y-2.5">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-background-100/80 hover:text-background-50 transition-colors">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold mb-4">
              <a href="#top" className="hover:text-accent-300 transition-colors">使用说明</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-100/80">
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-300" aria-hidden="true"></i>
                内容均为公开信息整理，仅供参考
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-300" aria-hidden="true"></i>
                待核实条目会单独标注，请勿当作定论
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-300" aria-hidden="true"></i>
                理性吃瓜，不传播来源不明的信息
              </li>
            </ul>
            <a
              href="#timeline"
              className="mt-5 h-10 px-4 rounded-md bg-accent-500 text-foreground-950 text-sm font-label inline-flex items-center gap-2 hover:bg-accent-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-shield-check-line" aria-hidden="true"></i>
              查看内容规范
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/70">
          <p>© 2026 {siteName} · 本站为演示站点，内容均为虚构示例，不代表任何真实人物或事件。</p>
          <div className="flex items-center gap-4">
            <a href="#top" className="hover:text-background-50 transition-colors whitespace-nowrap">隐私说明</a>
            <a href="#top" className="hover:text-background-50 transition-colors whitespace-nowrap">免责声明</a>
            <a href="#top" className="hover:text-background-50 transition-colors whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}